import { memo } from "react";
import { TemplatePage } from "../../2_ksbHub/0_TemplatePage/TemplatePage";
import { useAppContext } from "../../2_ksbHub/context/appContext";

import { BszFinderContext } from "./context/bszContext";

import useBszState from "./hooks/useBszState";
import useBszSocket from "./hooks/useBszSocket";

import LoadingBSZ from "./components/appFiller/LoadingBSZ";
import EmptyBSZState from "./components/appFiller/EmptyBSZState";
import BSZBody from "./components/BSZBody";

/**
 * =========================================================
 * ✅ BSZ FINDER PAGE
 * =========================================================
 */
function BSZFinderPage() {
  const { currentUser, isAnAdmin, bszFinderLoading } = useAppContext();

  /**
   * ✅ STATE
   */
  const bszState = useBszState();

  const {
    rooms,
    setRooms,
    loadMyReservation,
    loadClassesOverview,
    setServerNow,
    mySubjects,
    subjects,
  } = bszState;

  /**
   * ✅ SOCKET (global real-time sync)
   */

  useBszSocket({
    setRooms,
    loadMyReservation,
    setServerNow,
    loadClassesOverview,
  });

  /**
   * ✅ PERMISSIONS
   */
  const isBszAdmin = isAnAdmin;

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  let content;

  if (bszFinderLoading) {
    content = <LoadingBSZ />;
  } else if (!rooms || rooms.length === 0) {
    content = <EmptyBSZState />;
  } else {
    content = <BSZBody />;
  }

  return (
    <BszFinderContext.Provider
      value={{
        ...bszState,
        isBszAdmin,
        currentUser,
        mySubjects,
        subjects,
      }}
    >
      <TemplatePage type="bszFinder">{content}</TemplatePage>
    </BszFinderContext.Provider>
  );
}

export default memo(BSZFinderPage);
